import dayjs from "dayjs";
import Decimal from "decimal.js";
import { DATE_FORMAT, DATETIME_FORMAT, QUANTITY_DECIMAL_PLACES } from "@/config";

export const formatDate = (value) => dayjs(value).format(DATE_FORMAT);
export const formatDatetime = (value) => dayjs(value).format(DATETIME_FORMAT);
export const today = () => dayjs().format(DATE_FORMAT);
export const formatQuantity = (value, decimalPlaces = QUANTITY_DECIMAL_PLACES) => {
    if (value == null) return "";
    return new Decimal(value).toFixed(decimalPlaces, Decimal.ROUND_HALF_UP);
};

// Compares two numeric values for equality after rounding to the business
// decimal precision (QUANTITY_DECIMAL_PLACES). This absorbs IEEE-754 float
// representation drift (e.g. backend BigDecimal -> JSON number -> JS float
// -> Decimal) while correctly distinguishing values that differ at the last
// significant decimal place.
export const decimalEquals = (a, b) => {
    return new Decimal(a)
        .toDecimalPlaces(QUANTITY_DECIMAL_PLACES, Decimal.ROUND_HALF_UP)
        .equals(new Decimal(b).toDecimalPlaces(QUANTITY_DECIMAL_PLACES, Decimal.ROUND_HALF_UP));
};
